import React from "react";
import DayPills from "../shared/DayPills";
import TimeSelect from "../shared/TimeSelect";

const TIMEZONES = [
  "UTC",
  "Europe/London",
  "Europe/Paris",
  "Asia/Riyadh",
  "Asia/Dubai",
  "America/New_York",
  "America/Los_Angeles",
  "Asia/Kolkata",
];

export default function ScheduleStep({ state, setState }) {
  return (
    <div className="max-w-3xl mx-auto space-y-8">
      <div className="grid grid-cols-1 md:grid-cols-[220px_1fr] gap-4 items-start">
        <div>
          <div className="font-semibold text-gray-900">Start & end date</div>
          <div className="text-sm text-gray-500 mt-1">
            Set a start and end date for your campaign.
          </div>
        </div>
        <div className="flex flex-wrap gap-3 items-center">
          <input
            type="date"
            value={(state.startDate || "").slice(0, 10)}
            onChange={(e) =>
              setState((prev) => ({
                ...prev,
                startDate: e.target.value ? new Date(e.target.value).toISOString() : null,
              }))
            }
            className="border rounded-xl px-3 py-2 text-sm"
          />
          <input
            type="date"
            value={(state.endDate || "").slice(0, 10)}
            onChange={(e) =>
              setState((prev) => ({
                ...prev,
                endDate: e.target.value ? new Date(e.target.value).toISOString() : null,
              }))
            }
            className="border rounded-xl px-3 py-2 text-sm"
            placeholder="Campaign end date"
          />
          {state.endDate ? (
            <button
              type="button"
              onClick={() => setState((prev) => ({ ...prev, endDate: null }))}
              className="text-sm text-blue-600"
            >
              Clear end date
            </button>
          ) : null}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-[220px_1fr] gap-4 items-start">
        <div>
          <div className="font-semibold text-gray-900">Active hours</div>
          <div className="text-sm text-gray-500 mt-1">
            Set a timezone and active hours for your campaign.
          </div>
        </div>
        <div className="space-y-3">
          <select
            value={state.timezone || "Europe/London"}
            onChange={(e) => setState((prev) => ({ ...prev, timezone: e.target.value }))}
            className="w-full border rounded-xl px-3 py-2 text-sm"
          >
            {TIMEZONES.map((tz) => (
              <option key={tz} value={tz}>
                {tz}
              </option>
            ))}
          </select>
          <div className="flex gap-3 items-center">
            <span className="text-sm text-gray-500">From</span>
            <TimeSelect
              value={state.activeHoursStart || "09:00"}
              onChange={(v) => setState((prev) => ({ ...prev, activeHoursStart: v }))}
            />
            <span className="text-sm text-gray-500">To</span>
            <TimeSelect
              value={state.activeHoursEnd || "19:00"}
              onChange={(v) => setState((prev) => ({ ...prev, activeHoursEnd: v }))}
            />
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-[220px_1fr] gap-4 items-start">
        <div>
          <div className="font-semibold text-gray-900">Days</div>
          <div className="text-sm text-gray-500 mt-1">
            Select which days of the week you want your campaign to be active.
          </div>
        </div>
        <DayPills
          value={
            state.activeDays || ["monday", "tuesday", "wednesday", "thursday", "friday"]
          }
          onChange={(days) => setState((prev) => ({ ...prev, activeDays: days }))}
        />
      </div>
    </div>
  );
}
